import type { ComponentType, HTMLProps } from "react";
import { memo } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
// eslint-disable-next-line @typescript-eslint/no-unused-vars, unused-imports/no-unused-imports
import type { I18n as NewI18nComponent } from "@similarweb/i18n-provider";

interface I18nProps extends Omit<HTMLProps<HTMLSpanElement>, "translate" | "dangerouslySetInnerHTML"> {
    children: string | React.ReactNode;
    dataObj?: Record<string, any>;
    dangerouslySetInnerHTML?: boolean;
    component?: string | ComponentType<any>;
}

export const useTranslation = () => {
    const { translate } = useTranslate();

    return translate;
};

const I18n = (props: I18nProps) => {
    const { dataObj, dangerouslySetInnerHTML, children, component: Component = "span", ...restProps } = props;
    const { translate } = useTranslate();
    const text = children ? children.toString().replace(/(^['"])|(['"])$/g, "") : "";

    return dangerouslySetInnerHTML ? (
        <Component
            {...restProps}
            data-automation-i18n-key={text}
            dangerouslySetInnerHTML={{ __html: translate(text, dataObj) }}
        />
    ) : (
        <Component
            {...restProps}
            data-automation-i18n-key={text}
        >
            {translate(text, dataObj)}
        </Component>
    );
};

I18n.displayName = "I18n";

/**
 * @deprecated Use {@link NewI18nComponent} instead
 */
export default memo(I18n);
